import { handleActions } from 'redux-actions';
import actions from 'state/ui/actionCreators';

import initialState from 'state/ui/initial.state';

const reducer = handleActions(
  {
    [actions.closeMainMenu]: (state) => ({
      ...state,
      mainMenuOpened: false,
    }),
    [actions.toggleMainMenu]: (state) => ({
      ...state,
      mainMenuOpened: !state.mainMenuOpened,
    }),
    [actions.toggleSecondaryMenu]: (state) => ({
      ...state,
      secondaryMenuOpened: !state.secondaryMenuOpened,
    }),
    [actions.toggleAddressModal]: (
      state,
      { payload: { shipmentKey, stopType, isEditMode } }
    ) => ({
      ...state,
      addressModal:
        !state.addressModal && shipmentKey && stopType
          ? `${shipmentKey}-${stopType}`
          : '',
      addressModalEditMode: isEditMode,
    }),
    [actions.toggleNewAddressModal]: (state) => ({
      ...state,
      newAddressModal: !state.newAddressModal,
    }),
    [actions.toggleLoadingAddresses]: (
      state,
      { payload: { shipmentKey, stopType } }
    ) => ({
      ...state,
      loadingAddresses:
        !state.loadingAddresses && shipmentKey && stopType
          ? `${shipmentKey}-${stopType}`
          : '',
    }),
    [actions.toggleCancelOrderModalOpened]: (
      state,
      { payload: { order } }
    ) => ({
      ...state,
      cancelOrderModalOpened: order,
    }),
    [actions.togglePaymentDataPendingModalOpened]: (state) => ({
      ...state,
      paymentDataPendingModalOpened: !state.paymentDataPendingModalOpened,
    }),
    [actions.togglePaymentDataDeniedModalOpened]: (state) => ({
      ...state,
      paymentDataDeniedModalOpened: !state.paymentDataDeniedModalOpened,
    }),
    [actions.toggleModalFaqs]: (state) => ({
      ...state,
      modalFaqsOpened: !state.modalFaqsOpened,
    }),
    [actions.changeFormTooltipsData]: (state, { payload: { data } }) => ({
      ...state,
      formTooltips: {
        ...state.formTooltips,
        ...data,
      },
    }),
    [actions.clearFormTooltip]: (state, { payload: { key } }) => ({
      ...state,
      formTooltips: {
        ...state.formTooltips,
        [key]: undefined,
      },
    }),
    [actions.setFeedback]: (
      state,
      { payload: { feedback, success, params } }
    ) => ({
      ...state,
      feedback,
      feedbackParams: params,
      success,
    }),
    [actions.onScroll]: (state) => ({
      ...state,
      onTopScroll: false,
    }),
    [actions.onScrollTop]: (state) => ({
      ...state,
      onTopScroll: true,
    }),
    [actions.setFeedback]: (
      state,
      { payload: { feedback, success, params } }
    ) => ({
      ...state,
      feedback,
      feedbackParams: params,
      success,
    }),
    [actions.setFinishedPaymentData]: (state, { payload: { newValue } }) => ({
      ...state,
      finishedPaymentData: newValue,
    }),
    [actions.setCatalogStepName]: (state, { payload: { newValue } }) => ({
      ...state,
      catalogStepName: newValue,
    }),
  },
  initialState
);

export default reducer;
